import React, { Component } from 'react';
import { PasswordPrompt } from '../components/PasswordPrompt/PasswordPrompt';
import { Gallery } from '../components/Gallery/Gallery';
import { Photo } from '../components/Photo/Photo';
import { AppHeader } from '../components/AppHeader/AppHeader';
import { Pagination } from '../components/Pagination/Pagination';
import Lightbox from '../components/Lightbox/Lightbox';
import { uploadImage } from '../actions/FaceSearchActions';
import Dropzone from 'react-dropzone';
import { TYPES, TYPE_IMG, TYPE_GIF, listFolder, loadSources, bucketFiles } from '../lib/driveMedia';

const EMPTY_BUCKETS = { image: [], gif: [], video: [] };
const BIG_WIDTH = 1024; // ลดลง 50% จาก 2048 (2048 * 0.5 = 1024)
const PORT = window.location.port && window.location.port !== '80' ? ':' + process.env.REACT_APP_API_PORT : '';
const BASE_URL = window.location.protocol + '//' + window.location.hostname + PORT;
// Grid tiles are ~180-260px wide: serve 240px at 1x and 480px on high-density screens
const THUMB_URL = BASE_URL + '/imageproxy?sz=w240&id=';
const THUMB_2X_URL = BASE_URL + '/imageproxy?sz=w480&id=';
const BIG_URL = BASE_URL + '/imageproxy?sz=w' + BIG_WIDTH + '&id='; // ใช้ BIG_WIDTH ที่ลดลงแล้ว
const FILE_URL = BASE_URL + '/imageproxy?id=';
const UPLOAD_LIMIT = 10; // Megabytes

export default class GalleryContainer extends Component {
  constructor(props) {
    super(props);
    if (~props.match.path.indexOf('/photo/')) {
      this.state = { photoId: props.match.params.id };
    } else if (~props.match.path.indexOf('/gallery/')) {
      this.state = { galleryId: props.match.params.id };
    }

    this.state = {
      ...this.state,
      isPasswordProtected: false,
      isAuthenticated: false,
      lightboxOpen: false,
      lightboxIndex: 0,
      photos: EMPTY_BUCKETS,
      type: TYPE_IMG,
    };
  }

  checkPassword = async (password) => {
    try {
      const response = await fetch(`${BASE_URL}/check-password/${this.state.galleryId}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ password })
      });
      const data = await response.json();
      if (data.success) {
        this.setState({ isAuthenticated: true });
        this.updateGallery();
      } else {
        this.setState({ isAuthenticated: false, error: data.error });
      }
    } catch (error) {
      console.error(error);
      return false;
    }
  };

  onPageClick = event => {
    event.preventDefault();
    this.updateGallery();
  };

  onPhotoClick = (photoId) => {
    if (photoId) {
      const { photos = EMPTY_BUCKETS, type } = this.state;
      const currentPhotos = photos[type] || [];
      const index = currentPhotos.findIndex(photo => photo.id === photoId);

      this.setState({
        lightboxOpen: true,
        lightboxIndex: index >= 0 ? index : 0
      });
    }
  };

  onTypeSwitchClick = type => {
    if (this.state.photoId) {
      // Search corresponding item by the file name to switch to other type
      const name = this.getNameById(this.state.photoId, this.state.type);
      this.setState({ photoId: this.getIdByName(name, type), type });
    } else {
      this.setState({ type, currPage: 1 });
    }
  };

  onBackClick = () => {
    if (this.state.showMatches)
      if (this.state.photoId) this.setState({ photoId: undefined });
      else this.setState({ showMatches: false, currPage: this.state.savedPage });
    else this.updateGallery();
  };

  // Lightbox methods
  openLightbox = (index) => {
    this.setState({ lightboxOpen: true, lightboxIndex: index });
  };

  closeLightbox = () => {
    this.setState({ lightboxOpen: false });
  };

  nextImage = () => {
    const { photos = EMPTY_BUCKETS, type, lightboxIndex } = this.state;
    const currentPhotos = photos[type] || [];
    const nextIndex = (lightboxIndex + 1) % currentPhotos.length;
    this.setState({ lightboxIndex: nextIndex });
  };

  prevImage = () => {
    const { photos = EMPTY_BUCKETS, type, lightboxIndex } = this.state;
    const currentPhotos = photos[type] || [];
    const prevIndex = lightboxIndex === 0 ? currentPhotos.length - 1 : lightboxIndex - 1;
    this.setState({ lightboxIndex: prevIndex });
  };

  jumpToImage = (index) => {
    this.setState({ lightboxIndex: index });
  };

  removeFileExt = name => {
    return name.slice(0, name.lastIndexOf('.'));
  };

  getNameById = (id, type) => {
    const photo = this.state.photos[type].find(item => item.id === id);
    return photo && this.removeFileExt(photo.name);
  };

  getIdByName = (name, type) => {
    const photo = this.state.photos[type].find(item => this.removeFileExt(item.name) === name);
    return photo && photo.id;
  };

  onFileDrop = acceptedFiles => {
    const { galleryId } = this.state;
    const file = acceptedFiles[0];
    const span = document.querySelector('#uploadStatus');

    span.innerHTML = file
      ? `Uploading and analyzing photo...`
      : `Wrong file. Is it JPEG or PNG under ${UPLOAD_LIMIT} MB?`;

    if (file)
      uploadImage(file, galleryId)
        .then(res => {
          console.log(res.data);
          if (res.data.success) {
            const matches = {
              [TYPE_IMG]: res.data.photos.map(item => {
                return {
                  id: item.fileId,
                  full: BIG_URL + item.fileId,
                  thumb: THUMB_URL + item.fileId,
                  name: item.fileId,
                };
              }),
              [TYPE_GIF]: [], video: [],
            }; // TODO Add GIF support as well
            this.setState({ matches });
            span.innerHTML = `Matches found: ${res.data.photos.length || 'none'} `;
          } else {
            span.innerHTML = `${res.data.message}<br>`;
          }
        })
        .catch(err => {
          console.log(err);
        });
  };

  toItem = file => ({
    id: file.id,
    name: file.name,
    mimeType: file.mimeType,
    type: file.type,
    size: file.size,
    thumb: THUMB_URL + file.id,
    thumbSet: `${THUMB_URL + file.id} 240w, ${THUMB_2X_URL + file.id} 480w`,
    full: BIG_URL + file.id,
    file: FILE_URL + file.id,
  });

  // The server caches Drive listings for all guests; fall back to listing from the browser
  loadFiles = async ({ shareURL, sources }) => {
    try {
      const json = await fetch(`${BASE_URL}/gallery-files/${this.state.galleryId}`).then(response => response.json());
      if (!json.success) throw new Error(json.error);
      return { rootFiles: json.rootFiles, sourceResults: json.sources };
    } catch (error) {
      console.log('Falling back to client-side Drive listing:', error.message);
      const rootFiles = await listFolder(shareURL).catch(listError => {
        console.log(listError);
        return [];
      });
      return { rootFiles, sourceResults: sources && sources.length ? await loadSources(sources) : null };
    }
  };

  useDefaultAssets = () => {
    this.props.onSetBackground('/assets/background.jpg');
    this.props.onSetLogo('/assets/logo.png');
  };

  updateGallery = () => {
    const { galleryId } = this.state;

    fetch(BASE_URL + '/gallery/' + galleryId, { method: 'POST' }) // Query server for a gallery parameters
      .then(response => response.json())
      .then(async json => {
        // Check if gallery exists
        if (!json.success || !json.data) {
          throw new Error('Gallery not found');
        }

        const { shareURL, sources, imagesPerPage, background, logo, faceset_token } = json.data;

        const { rootFiles, sourceResults } = await this.loadFiles({ shareURL, sources });

        // Logo and background live in the pasted (parent) folder
        const backgroundFile = rootFiles.find(file => file.name === background);
        const logoFile = rootFiles.find(file => file.name === logo);
        this.props.onSetBackground(backgroundFile ? FILE_URL + backgroundFile.id : '/assets/background.jpg');
        this.props.onSetLogo(logoFile ? FILE_URL + logoFile.id : '/assets/logo.png');

        // Old galleries have no sources: use the parent folder with legacy per-file typing
        const buckets = sourceResults
          ? bucketFiles(sourceResults, [])
          : bucketFiles([{ type: null, files: rootFiles }], [background, logo]);
        const photos = {};
        TYPES.forEach(type => (photos[type] = buckets[type].map(this.toItem)));

        this.setState({
          photos,
          imagesPerPage,
          type: TYPES.find(type => photos[type].length) || TYPE_IMG,
          currPage: 1,
          photoId: undefined,
          showMatches: false,
          detectOn: !!faceset_token,
        });
      })
      .catch(err => {
        console.log(err);
        this.useDefaultAssets();
        if (err.message === 'Gallery not found') this.setState({ notFound: true });
      });
  };

  componentDidUpdate(prevProps) { }

  componentDidMount() {
    if (this.state.galleryId) {
      // Check if gallery is password protected
      fetch(`${BASE_URL}/gallery-auth/${this.state.galleryId}`)
        .then(res => res.json())
        .then(data => {
          this.setState({
            isPasswordProtected: data.isProtected,
            isAuthenticated: !data.isProtected
          });
          if (!data.isProtected) {
            this.updateGallery();
          }
        });
    }

    // Set up global function for thumbnail clicks
    window.lightboxThumbnailClick = this.jumpToImage;
  }

  componentWillUnmount() {
    // Clean up global function
    if (window.lightboxThumbnailClick) {
      delete window.lightboxThumbnailClick;
    }

    // Reset background styles
    document.body.style.backgroundImage = "";
    document.body.style.backgroundSize = "";
    document.body.style.backgroundPosition = "";
    document.body.style.backgroundRepeat = "";
    document.body.style.backgroundAttachment = "";
  }

  render() {
    const { isPasswordProtected, isAuthenticated, error } = this.state;

    if (this.state.notFound) {
      return (
        <div className="gallery-not-found-page">
          <div className="gallery-not-found" role="alert">
            <h1>Gallery not found</h1>
            <p>This link may be mistyped or the gallery has been removed.</p>
          </div>
        </div>
      );
    }

    if (isPasswordProtected && !isAuthenticated) {
      return (<PasswordPrompt error={error} onSubmit={this.checkPassword} />);
    }

    const {
      photoId,
      photos = EMPTY_BUCKETS,
      matches = EMPTY_BUCKETS,
      type,
      currPage,
      imagesPerPage,
      showDropZone,
      showMatches,
      detectOn,
      lightboxOpen,
      lightboxIndex,
    } = this.state;
    const { logo, background } = this.props;
    if (background) {
      document.body.style.backgroundImage = "url('" + background + "')";
      document.body.style.backgroundSize = "cover";
      document.body.style.backgroundPosition = "center";
      document.body.style.backgroundRepeat = "no-repeat";
      document.body.style.backgroundAttachment = "fixed";
    } else {
      // Reset background styles when no background
      document.body.style.backgroundImage = "";
      document.body.style.backgroundSize = "";
      document.body.style.backgroundPosition = "";
      document.body.style.backgroundRepeat = "";
      document.body.style.backgroundAttachment = "";
    }
    return (
      <div className="gallery-container">
        <AppHeader
          logo={logo}
          onTypeSwitchClick={this.onTypeSwitchClick}
          type={type}
          counts={{ image: photos.image.length, gif: photos.gif.length, video: photos.video.length }}
        />
        {(photos[type] || matches[TYPE_IMG]) && (
          <React.Fragment>
            <Gallery
              key={showMatches ? `matches-${type}` : type}
              photos={showMatches ? matches : photos}
              type={type}
              currPage={currPage}
              imagesPerPage={imagesPerPage}
              onPhotoClick={this.onPhotoClick}
            />
          </React.Fragment>
        )}

        {/* Lightbox */}
        {lightboxOpen && (
          <Lightbox
            isOpen={lightboxOpen}
            onClose={this.closeLightbox}
            currentImage={(photos[type] || [])[lightboxIndex]}
            images={photos[type] || []}
            onNext={this.nextImage}
            onPrev={this.prevImage}
            currentIndex={lightboxIndex}
          />
        )}
        {showDropZone && (
          <div className="face-select">
            <button className="close" onClick={() => this.setState({ showDropZone: false })}>
              ×
            </button>
            <Dropzone
              accept="image/jpeg, image/png"
              maxSize={UPLOAD_LIMIT * 1024 * 1024}
              multiple={false}
              onDrop={this.onFileDrop}
            >
              {({ getRootProps, getInputProps }) => (
                <section>
                  <div {...getRootProps()}>
                    <input {...getInputProps()} accept=".jpg,.jpeg,.png" />
                    <p>
                      Drop a file here or click to select.
                      <br />
                      JPEG or PNG up to {UPLOAD_LIMIT} MB
                    </p>
                  </div>
                  <span id="uploadStatus" />
                  {!!matches[TYPE_IMG].length && <img src={matches[TYPE_IMG][0].full} alt="" width="320" />}
                </section>
              )}
            </Dropzone>
            {!!matches[TYPE_IMG].length && (
              <button onClick={() => this.setState({ showDropZone: false, showMatches: true, currPage: 1, savedPage: this.state.currPage })}>
                View Matches
              </button>
            )}
          </div>
        )}
        {!(showDropZone || showMatches || !detectOn) && (
          <a id="face" style={{ color: '#00000000' }} onClick={() => this.setState({ showDropZone: true })}>
            Search face
          </a>
        )}
      </div>
    );
  }
}
